import React, { FC } from 'react';
import { useTournamentPrizes } from '../../../../hooks/useTournamentPrizes';
import { Loader } from '@ui-kit/components/loader';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import useInput from '@utils/hooks/useInput';

type PropsType = {
  entryFee: number;
  extraBonus: string;
  pairing: string;
};

export const PendingTournamentsCalculation: FC<PropsType> = ({
  entryFee,
  extraBonus,
  pairing,
}: PropsType) => {
  const players = useInput('8');
  const { data, loading, error } = useTournamentPrizes({
    entryFee,
    extraBonus,
    pairing,
    np: Number(players.value),
  });

  const renderListPrizes = (data: number[]) => {
    return data.map((item, index) => {
      return (
        <p key={`${index}_${item}`}>{`${
          index + 1
        }-st place - wins ${item} Tickets`}</p>
      );
    });
  };
  const classes = {
    root: 'root',
    select: 'select',
    icon: 'icon',
    iconOpen: 'iconOpen',
    iconFilled: 'iconFilled',
  };

  const loaderJsx = loading && <Loader className="loader-container--black" />;
  const prizesJsx = data && renderListPrizes(data);

  return (
    <div className="pending__calculate">
      {loaderJsx}
      <div className="calculate-prizes">
        <header className="calculate-prizes__players">
          <div className="calculate-prizes__title">Number of players</div>
          <div className="calculate-prizes__select">
            <Select
              classes={classes}
              labelId="demo-customized-select-label"
              id="demo-customized-select-label"
              {...players}
            >
              {Array.from({ length: 24 }, (_, i) =>
                i < 18 ? i + 3 : 20 + (i + 3 - 20) * 5
              ).map((i) => (
                <MenuItem value={i}>{i}</MenuItem>
              ))}
            </Select>
          </div>
        </header>
        <main className="calculate-prizes__body">{prizesJsx}</main>
      </div>
    </div>
  );
};
